import {HttpEvent, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";

export function highlightBackend(url: string, method: string, request: HttpRequest<any>): Observable<HttpEvent<any>> {

  if (url.endsWith('/highlights/v1') && method === "GET") {

    let data = [];

    if (request.params.has("archived") && request.params.get("archived") == "Y") {
      data = [
        {
          "type": "highlight",
          "id": 510,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 511,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 512,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 513,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 514,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 515,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 516,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 517,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 518,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 519,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 520,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 521,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        },
        {
          "type": "highlight",
          "id": 522,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 523,
          "attributes": {
            "category": "announcement",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-12T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        }
      ];
    }
    else {
      data = [
        {
          "type": "highlight",
          "id": 555,
          "attributes": {
            "category": "2",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one doesn't have a link.",
            "startDate": "2017-10-13T15:29:03-05:00",
            "expirationDate": "2017-11-18T15:29:03-05:00"
          }
        },
        {
          "type": "highlight",
          "id": 546,
          "attributes": {
            "category": "3",
            "subject": "This is a title",
            "description": "This is the full content of what the highlight is about. This one has a link.",
            "startDate": "2017-10-15T15:29:03-05:00",
            "expirationDate": "2017-11-21T15:29:03-05:00",
            "link": {
              "href": "https://10central.kc.frb.org"
            }
          }
        }
      ];
    }

    return new Observable(resp => {
      resp.next(new HttpResponse({
        status: 200,
        body: {
          "data": []
        }
      }));
      resp.complete();
    });

  }

}
